// KL - prenatal and postnatal personal trainer (with pantang context).
const content = {
    slug: 'prenatal-postnatal-personal-trainer',
    title: 'Prenatal & Postnatal Personal Trainer in KL | After Pantang',
    description: (c) =>
        `Pregnancy and postnatal personal training in Kuala Lumpur: safe exercise before birth and after pantang, at home. From ${c.money(c.lowest, 0)} a session.`,
    eyebrow: 'KL · Pre & postnatal',
    h1: 'Prenatal and Postnatal Personal Trainer in Kuala Lumpur',
    lead: 'Stay strong through pregnancy, then rebuild gently once your pantang (confinement) is over - with a trainer who understands both the medical guidance and Malaysian confinement traditions.',
    image: 'personal-trainer/mother-practicing-yoga-with-her-baby-daughter-home.jpg',
    imageAlt: 'Mother doing gentle exercise at home with her baby',
    facts: ['Pregnancy-safe training', 'Starts after pantang', 'Female trainers available'],
    ctaLabel: 'Request a pre/postnatal trainer',
    matchSummary: 'a prenatal or postnatal personal trainer in KL',
    packagesTitle: 'Packages',
    packagesIntro: 'A 14-session package suits late pregnancy or the first weeks after pantang; most mothers continue afterwards.',
    sections: [
        {
            title: 'Before the baby',
            items: [
                'Strength for back and hips as the bump grows.',
                'Pelvic floor and breathing practice.',
                'Walking and low-impact cardio - indoors on hot or hazy days.',
                'Everything cleared with your gynae first.',
            ],
        },
        {
            title: 'After pantang',
            tone: 'muted',
            paragraphs: [
                'Pantang traditionally lasts around 30 to 44 days, and it is a time for rest and recovery. Formal training usually starts after it ends and after your postnatal check-up. Gentle breathing and pelvic floor exercises are often fine earlier - ask your doctor.',
                'Your trainer rebuilds in stages: breathing and pelvic floor, deep core (with care for any abdominal separation), then strength for lifting and carrying your baby, then general fitness. Sessions fit around feeding and naps at home.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Can I exercise during pantang?',
            answer: 'Rest is the priority. Gentle breathing and pelvic floor exercises are usually safe early on with your doctor\'s OK; structured training starts after pantang and your postnatal check.',
        },
        {
            question: 'When can I start after a caesarean?',
            answer: 'Usually later than after a normal delivery - follow your doctor\'s clearance, often from around eight weeks.',
        },
        {
            question: 'Can I get a female trainer?',
            answer: (c) => `Yes, female trainer requests add ${c.money(c.mods.female, 0)} a session.`,
        },
    ],
    schema: { name: 'Prenatal and Postnatal Personal Training in Kuala Lumpur' },
}

export default content
